// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"1053e4f9","180":"b6bdb83d","208":"f6c295be","774":"af7091fb","787":"4f84cf06","814":"0ea0da7a","820":"be0f0905","851":"f17b7d3a","916":"9f1d23c9"}[chunkId] + ".chunk.js";
};